import { initializeNovaAnalytics } from './novaAnalytics';
import { initializeNovaExperiments } from './novaExperiments';

initializeNovaAnalytics();

initializeNovaExperiments();
